import { OnboardingQueryProvider } from 'onboarding/modules/shared'

import { configuredScreeningValue, isRequestId, screeningOfParameters } from '../model/helpers'

import { CompetitorBadActorReview } from './components/CompetitorBadActorReview'
import { COMPETITOR_BAD_ACTOR_REVIEW_TEXT as TEXT, useReviewText } from './translations'

interface ICompetitorBadActorReviewFormProps {
  requestId: number
  parameters: unknown
}

export const CompetitorBadActorReviewForm = ({
  requestId,
  parameters,
}: ICompetitorBadActorReviewFormProps) => {
  const text = useReviewText()
  const screening = screeningOfParameters(parameters)
  const requestIsValid = isRequestId(requestId)

  if (screening !== null && requestIsValid) {
    return (
      <OnboardingQueryProvider>
        <CompetitorBadActorReview requestId={requestId} screening={screening} />
      </OnboardingQueryProvider>
    )
  }

  const configuredValue = configuredScreeningValue(parameters)

  return (
    <>
      {screening === null && (
        <p role="alert">
          {configuredValue === null
            ? text(TEXT.screeningMissing)
            : text(TEXT.screeningUnknown, { value: configuredValue })}
        </p>
      )}
      {!requestIsValid && (
        <p role="alert">{text(TEXT.requestInvalid, { value: String(requestId) })}</p>
      )}
    </>
  )
}
